import service from '@/middleware'
import store from '@/store/store'

class UploadService {
    /**
     * Función para subir archivos
     * @param {*} file
     * @param {*} onUploadProgress
     */
    upload(file, onUploadProgress) {
        let formData = new FormData();
        formData.append('file', file);
        const email = store.getters['user/getEmail']

        return service.http.post('/api/thing/massive-upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'email': email
            },
            onUploadProgress
        });
    }
}

export default new UploadService();